import * as tslib_1 from "tslib";
import { select, Store } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom, filter } from 'rxjs/operators';
import { toPayload, withPredicateFrom } from '../../core/helpers/rx-pipes';
import { UserService } from '../services/user.service';
import * as user from '../actions/user';
import * as pages from '../../base/actions/pages.actions';
import * as menus from '../../base/actions/menus.actions';
import * as status from '../../base/actions/status.actions';
import * as fromUser from '../reducers';
import * as fromAuth from '../../auth/reducers';
import * as moment from 'moment';
import { CustomersService } from '../services/customers.service';
import { Router } from '@angular/router';
var UserEffects = /** @class */ (function () {
    function UserEffects(actions$, userService, router, customerService, store, translate) {
        var _this = this;
        this.actions$ = actions$;
        this.userService = userService;
        this.router = router;
        this.customerService = customerService;
        this.store = store;
        this.translate = translate;
        this.getUserContext$ = this.actions$.ofType(user.GET)
            .pipe(switchMap(function () {
            return _this.userService.userContext()
                .pipe(map(function (context) { return new user.GetSuccess(context); }), catchError(function (e) { return of(new user.GetFailed(e)); }));
        }));
        this.setCustomer$ = this.actions$.ofType(user.SET_CUSTOMER)
            .pipe(toPayload(), switchMap(function (customerId) {
            return _this.customerService.getCustomerById(customerId)
                .pipe(map(function (customer) { return new user.SetCustomerSuccess(customer); }), catchError(function (e) { return of(new user.SetCustomerFailed(e)); }));
        }));
        this.setCustomerSuccess$ = this.actions$.ofType(user.SET_CUSTOMER_SUCCESS)
            .pipe(switchMap(function (action) {
            _this.router.navigate(['/home']);
            return [new pages.Init(true), new menus.Init(true), new status.SetHeader(true)];
        }));
        this.applyLanguageAfterLogin$ = this.actions$.ofType(user.GET_SUCCESS)
            .pipe(toPayload(), map(function (user) { return user.preferences.language; }), tap(this.changeLanguage.bind(this)));
        this.addHeaderAfterLogin$ = this.actions$.pipe(ofType(user.GET_SUCCESS), withLatestFrom(this.store.pipe(select(fromAuth.isSalesRep))), filter(function (_a) {
            var action = _a[0], isSalesRep = _a[1];
            return !isSalesRep;
        }), map(function () { return new status.SetHeader(true); }));
        this.setLanguage$ = this.actions$.ofType(user.SET_LANGUAGE)
            .pipe(toPayload(), withPredicateFrom(this.store.pipe(select(fromUser.getLoggedIn))), withLatestFrom(this.store.pipe(select(fromUser.getUserContext)), function (lang, userCtx) { return (tslib_1.__assign({}, userCtx, { language: lang })); }), map(function (prefs) { return new user.Set(prefs); }));
        this.savePreferences$ = this.actions$.ofType(user.SET)
            .pipe(toPayload(), switchMap(function (preferences) {
            return _this.userService.savePreferences(preferences)
                .pipe(map(function (pref) { return new user.SetSuccess(pref); }), catchError(function (e) { return of(new user.SetFailed(e)); }));
        }));
        this.applyLanguageAfterSet = this.actions$.ofType(user.SET_SUCCESS)
            .pipe(toPayload(), map(function (prefs) { return prefs.language; })).pipe(tap(this.changeLanguage.bind(this)));
        this.changeLangPreLogin$ = this.actions$.ofType(user.SET_LANGUAGE)
            .pipe(toPayload(), withPredicateFrom(this.store.pipe(select(fromUser.getLoggedIn)), function (loggedIn) { return !loggedIn; })).pipe(tap(function (state) { return _this.changeLanguage(state); }));
    }
    UserEffects.prototype.changeLanguage = function (lang) {
        this.translate.use(lang);
        moment.locale(lang);
    };
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], UserEffects.prototype, "getUserContext$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], UserEffects.prototype, "setCustomer$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], UserEffects.prototype, "setCustomerSuccess$", void 0);
    tslib_1.__decorate([
        Effect({ dispatch: false }),
        tslib_1.__metadata("design:type", Observable)
    ], UserEffects.prototype, "applyLanguageAfterLogin$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], UserEffects.prototype, "addHeaderAfterLogin$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], UserEffects.prototype, "setLanguage$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], UserEffects.prototype, "savePreferences$", void 0);
    tslib_1.__decorate([
        Effect({ dispatch: false }),
        tslib_1.__metadata("design:type", Observable)
    ], UserEffects.prototype, "applyLanguageAfterSet", void 0);
    tslib_1.__decorate([
        Effect({ dispatch: false }),
        tslib_1.__metadata("design:type", Object)
    ], UserEffects.prototype, "changeLangPreLogin$", void 0);
    return UserEffects;
}());
export { UserEffects };
